export default "__VITE_ASSET__1ae2ba1a__"